import {
  targetId,
  targetName,
  targetAddress,
  cystackEmail
} from '../constants/cystackConfig';

export const cystackGetTargetInfo = () => ({
  targetId,
  targetName,
  targetAddress,
  cystackEmail
});
